<template>
    <v-layout fluid v-resize="onResize">
        <v-card class="mx-auto" elevation="4" width="100%">
            <v-toolbar
                v-if="deptColors[deptTitle]"
                :color="deptColors[deptTitle]"
                class="relative-toolbar"
            >
                <v-tooltip text="Clear filters to reorder jobs">
                    <template #activator="{ props }">
                        <span v-bind="props">
                            <v-btn
                                v-if="manager"
                                :disabled="hasActiveFilters"
                                color="primary"
                                variant="outlined"
                                @click="openReorderModal"
                            >
                                Reorder Jobs
                            </v-btn>
                        </span>
                    </template>
                </v-tooltip>
                <v-spacer />

                <v-toolbar-title class="text-center toolbar-title-center">
                    {{ deptTitle }} - {{ machine_id }}
                </v-toolbar-title>
                <div class="toolbar-search-wrapper">
                    <v-text-field
                        v-model="table.search"
                        label="Search"
                        prepend-inner-icon="mdi:mdi-magnify"
                        dense
                        variant="underlined"
                        clearable
                        hide-details
                    />
                </div>

                <div class="timer ma-2 pa-2">
                    {{ timer }}
                </div>
            </v-toolbar>

            <EasyDataTable
                ref="dataTable"
                :headers="table.headers"
                :items="sortedFilteredTableData"
                :body-text-direction="bodyTextDirection"
                :header-text-direction="bodyTextDirection"
                table-class-name="customize-table"
                theme-color="#242939"
                :table-height="windowSize.y - 85 - 85"
                :rows-per-page="10000"
                :body-row-class-name="getRowClassName"
                :loading="loading"
                :hide-footer="true"
                :search-value="table.search"
                no-hover
                show-index
                @click-row="showTabletView"
            >
                <!-- v-model:items-selected="remove" -->
                <template #loading>
                    <v-progress-circular
                        color="blue-lighten-3"
                        indeterminate
                        :size="120"
                    >
                        <v-img
                            src="/images/d3_connect.png"
                            v-if="loading"
                            :size="10"
                            class="loading-spinner"
                            :style="{
                                marginLeft: '9px',
                            }"
                            indeterminate
                        ></v-img>
                    </v-progress-circular>
                </template>


                <!--JobNum-->

                <template #header-JobNum="header">
                    <div
                        class="filter-column"
                        style="
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                        "
                    >
                        <div
                            style="display: flex; align-items: center; gap: 4px"
                        >
                            <v-icon
                                :color="
                                    filters.JobNum.selection ? 'green' : 'none'
                                "
                                icon="fa-solid fa-filter"
                                size="x-small"
                                @click="
                                    filters.JobNum.show = !filters.JobNum.show
                                "
                            />
                            {{ header.text }}
                        </div>

                        <v-select
                            v-if="filters.JobNum.show"
                            label="Filter"
                            clearable
                            variant="outlined"
                            density="comfortable"
                            hide-details
                            :items="filters.JobNum.options"
                            v-model="filters.JobNum.selection"
                            @update:modelValue="filters.JobNum.show = false"
                            style="
                                min-width: 160px;
                                max-width: 250px;
                                margin-top: 4px;
                            "
                        />
                    </div>
                </template>

                <!--PartNum-->

                <template #header-PartNum="header">
                    <div
                        class="filter-column"
                        style="
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                        "
                    >
                        <div
                            style="display: flex; align-items: center; gap: 4px"
                        >
                            <v-icon
                                :color="
                                    filters.PartNum.selection ? 'green' : 'none'
                                "
                                icon="fa-solid fa-filter"
                                size="x-small"
                                @click="
                                    filters.PartNum.show = !filters.PartNum.show
                                "
                            />
                            {{ header.text }}
                        </div>

                        <v-select
                            v-if="filters.PartNum.show"
                            label="Filter"
                            clearable
                            variant="outlined"
                            density="comfortable"
                            hide-details
                            :items="filters.PartNum.options"
                            v-model="filters.PartNum.selection"
                            @update:modelValue="filters.PartNum.show = false"
                            style="
                                min-width: 160px;
                                max-width: 250px;
                                margin-top: 4px;
                            "
                        />
                    </div>
                </template>

                <template #item-Active="item">
                    <div v-if="item.Active > 0">
                        <i class="mdi mdi-circle active"></i>
                    </div>
                    <div v-else>
                        <i class="mdi mdi-circle inactive"></i>
                    </div>
                </template>
                <template #item-JobNum="item">
                    <div>{{ item.JobNum }}</div>
                    <div>
                        <v-chip
                            color="white"
                            style="background-color: rgba(23, 162, 184, 255)"
                        >
                            Due: {{ item.ShipByDate }}
                        </v-chip>
                    </div>
                </template>
                <template #item-PartNum="item">
                    <div>{{ item.PartNum }}</div>
                    <div>
                        <v-chip
                            color="white"
                            style="background-color: rgba(23, 162, 184, 255)"
                        >
                            {{ item.OpDesc }}
                        </v-chip>
                    </div>
                </template>

                <template #item-RemainQty="item">
                    <strong>{{ item.RemainQty }}</strong>
                </template>

                <template #item-Approved="item">
                    <div v-if="item.Approved === 3">
                        <i class="mdi mdi-check-circle approved"></i>
                    </div>
                    <div v-else-if="item.Approved === 2">
                        <i class="mdi mdi-circle-half-full semi-approved"></i>
                    </div>
                    <div v-else>
                        <i class="mdi mdi-close-circle unapproved"></i>
                    </div>
                </template>

                <!-- <template #item-Select="item">
                    <v-checkbox
                        v-model="remove"
                        :value="item"
                        @click="checkBug(item)"
                    ></v-checkbox>
                </template> -->
            </EasyDataTable>

            <v-row style="background-color: #e0e0e0">
                <v-col class="ma-2"
                    >Showing 1 to {{ numberOfRows }} of
                    {{ numberOfRows }} entries
                </v-col>
                <!-- <v-col class="text-end ma-2">
                    <v-btn
                        v-if="this.remove.length > 0"
                        size="x-large"
                        color="error"
                        @click="prepareForRemoval"
                        >Remove Operations</v-btn
                    >
                </v-col> -->
            </v-row>
        </v-card>
    </v-layout>

    <v-dialog
        v-model="tabletViewDialog"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
        persistent
        style="max-height: 100vh"
    >
        <Tablet
            :rowID="passRowID"
            :mainMachineProps="machine_id"
            :job_object="job_object"
            :manager="manager"
            @closeTabletView="closeTabletView"
        />
    </v-dialog>
    <v-dialog v-model="reorderDialog" max-width="80%">
        <v-card class="scroll">
            <v-toolbar>
                <v-toolbar-title>Change Job Order</v-toolbar-title>

                <v-spacer />

                <v-btn
                    color="green"
                    class="mr-2"
                    variant="outlined"
                    @click="saveReorder"
                >
                    Save New Order
                </v-btn>

                <v-btn
                    color="black"
                    variant="text"
                    @click="reorderDialog = false"
                >
                    (X) CLOSE
                </v-btn>
            </v-toolbar>
            <v-container fluid>
                <v-overlay
                    :model-value="overlay"
                    class="align-center justify-center"
                >
                    <v-progress-circular
                        color="blue-lighten-3"
                        indeterminate
                        :size="120"
                    >
                        <v-img
                            src="/images/d3_connect.png"
                            v-if="overlay"
                            :size="10"
                            class="loading-spinner"
                            :style="{
                                marginLeft: '9px',
                            }"
                            indeterminate
                        ></v-img>
                    </v-progress-circular>
                </v-overlay>
                <v-row>
                    <v-col v-if="alertSuccess" cols="12">
                        <v-alert
                            dense
                            outlined
                            prominent
                            :model-value="alertSuccess"
                            shaped
                            text
                            type="success"
                            >Updated!
                        </v-alert>
                    </v-col>
                    <v-col cols="6">
                        <v-alert
                            v-if="recommendedSoonestDue"
                            type="info"
                            dense
                            closable
                            variant="tonal"
                        >
                            Soonest due: {{ recommendedSoonestDue.JobNum }} —
                            {{ recommendedSoonestDue.PartNum }} ({{
                                recommendedSoonestDue.ShipByDate
                            }})
                        </v-alert>
                    </v-col>
                    <v-col cols="6">
                        <v-alert
                            v-if="recommendedLowestRemQty"
                            type="info"
                            dense
                            closable
                            variant="tonal"
                        >
                            Lowest remaining qty:
                            {{ recommendedLowestRemQty.JobNum }} —
                            {{ recommendedLowestRemQty.PartNum }} ({{
                                recommendedLowestRemQty.RemainQty
                            }})
                        </v-alert>
                    </v-col>
                    <v-col col="12">
                        <table>
                            <thead>
                                <tr>
                                    <th>Order #</th>
                                    <th>JobNum</th>
                                    <th>PartNum</th>
                                    <th>Material</th>
                                    <th>Run Qty</th>
                                    <th>Rem Qty</th>
                                    <th>Approved</th>
                                    <th>Due Date</th>
                                </tr>
                            </thead>

                            <draggable
                                :list="reorderItems"
                                tag="tbody"
                                style="cursor: move"
                                @start="isDragging = true"
                                @end="isDragging = false"
                            >
                                <tr
                                    v-for="(item, index) in reorderItems"
                                    :key="item.id"
                                    :class="{
                                        moved: index !== item.OriginalIndex,
                                    }"
                                >
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.JobNum }}</td>
                                    <td>{{ item.PartNum }}</td>
                                    <td>{{ item.Material }}</td>
                                    <td>{{ item.RunQty }}</td>
                                    <td>{{ item.RemainQty }}</td>
                                    <td>
                                        <div v-if="item.Approved === 3">
                                            <i
                                                class="mdi mdi-check-circle approved"
                                            ></i>
                                        </div>
                                        <div v-else-if="item.Approved === 2">
                                            <i
                                                class="mdi mdi-circle-half-full semi-approved"
                                            ></i>
                                        </div>
                                        <div v-else>
                                            <i
                                                class="mdi mdi-close-circle unapproved"
                                            ></i>
                                        </div>
                                    </td>
                                    <td>{{ item.ShipByDate }}</td>
                                </tr>
                            </draggable>
                        </table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import GuestLayout from "../../../Layouts/GuestLayout.vue";
import Tablet from "./Tablet.vue";
import { VueDraggableNext } from "vue-draggable-next";

export default {
    components: { Tablet, draggable: VueDraggableNext },
    layout: [GuestLayout],
    props: {
        errors: Object,
        auth: Object,
    },

    data() {
        return {
            table: {
                headers: [

                    { text: "Active", value: "Active" },

                    { text: "Job #", value: "JobNum" },
                    { text: "Part #", value: "PartNum" },
                    { text: "Material", value: "Material" },
                    { text: "Run Qty", value: "RunQty" },
                    { text: "Rem Qty", value: "RemainQty" },
                    { text: "Approved", value: "Approved" },
                    // { text: "", value: "Select" },
                ],
                items: [],
                search: "",
            },
            deptColors: {
                CNC: "#FFE082",
                ASM: "pink",
                SIL: "#BBDEFB",
                SAW: "green",
                VACF: "blue",
            },
            filters: {
                JobNum: {
                    show: false,
                    options: [],
                    selection: "",
                },
                PartNum: {
                    show: false,
                    options: [],
                    selection: "",
                },
            },
            overlay: false,
            alertSuccess: false,
            bodyTextDirection: "center",
            sortBy: ["Active"],
            sortType: ["desc"],
            // remove: [],
            loading: false,
            tabletViewDialog: false,
            passRowID: null,
            job_object: null,
            timer: 180,
            machine_id: null,
            manager: null,
            recommendedLowestRemQty: null,
            recommendedSoonestDue: null,
            reordering: false,
            reorderDialog: false,
            reorderItems: [],
            windowSize: {
                x: 0,
                y: 0,
            },
        };
    },
    mounted() {
        this.getJobs();
        this.startTimer();
    },
    watch: {
        timer(newVal) {
            if (newVal === 0) {
                this.getJobs();
                this.timer = 60;
            }
        },
        reorderDialog(newVal) {
            if (!newVal) {
                this.reorderItems = [];
                this.alertSuccess = false;
                this.recommendedLowestRemQty = null;
                this.recommendedSoonestDue = null;
            }
        },
    },
    computed: {
        filteredTableData() {
            // reset to page 1 when filters change
            if (this.$refs.dataTable) {
                this.$refs.dataTable.updatePage(1);
            }

            return this.table.items.filter((item) => {
                /* JOB NUM */
                if (
                    this.filters.JobNum.selection &&
                    this.filters.JobNum.selection !== "All"
                ) {
                    if (
                        !item.JobNum ||
                        item.JobNum.toLowerCase() !==
                            this.filters.JobNum.selection.toLowerCase()
                    ) {
                        return false;
                    }
                }

                /* PART NUM */
                if (
                    this.filters.PartNum.selection &&
                    this.filters.PartNum.selection !== "All"
                ) {
                    if (
                        !item.PartNum ||
                        item.PartNum.toLowerCase() !==
                            this.filters.PartNum.selection.toLowerCase()
                    ) {
                        return false;
                    }
                }

                return true;
            });
        },
        sortedFilteredTableData() {
            // console.log([...this.filteredTableData].sort(
            //     this.priorityThenActiveSort))
            return [...this.filteredTableData].sort(
                this.priorityThenActiveSort
            );
        },
        numberOfRows() {
            return this.table.items.length;
        },
        deptTitle() {
            let path = window.location.pathname;
            let regex = /\/labor-(\w+)\/\w+/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },

        resourceId() {
            let path = window.location.pathname;
            let regex = /\/labor-\w+\/(\w+)/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
        hasActiveFilters() {
            return (
                (this.filters.JobNum.selection !== null &&
                    this.filters.JobNum.selection !== "") ||
                (this.filters.PartNum.selection !== null &&
                    this.filters.PartNum.selection !== "")
            );
        },
    },
    methods: {
        async getJobs() {
            this.loading = true;

            try {
                await axios
                    .get(
                        route("legacy-api.getSpecificTablet", {
                            tabletId: this.resourceId,
                        })
                    )
                    .then((response) => {
                        this.machine_id = response.data.data;
                        this.manager = response.data.manager;
                    });
            } catch (err) {
                console.log(err);
            }

            //// need to wait to the top call
            switch (this.deptTitle) {
                case "ADM":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "CNC":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "ASM":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.resourceId,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "SIL":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "SAW":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "VACF":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
            }
            this.table.items.forEach((item) => {
                if (!this.filters.JobNum.options.includes(item.JobNum)) {
                    this.filters.JobNum.options.push(item.JobNum);
                }
                if (!this.filters.PartNum.options.includes(item.PartNum)) {
                    this.filters.PartNum.options.push(item.PartNum);
                }
            });
            this.filters.JobNum.options = this.sortArray(
                this.filters.JobNum.options
            );
            this.filters.PartNum.options = this.sortArray(
                this.filters.PartNum.options
            );

            this.loading = false;
        },
        startTimer() {
            setInterval(() => {
                if (this.timer > 0) {
                    this.timer--;
                }
            }, 1000);
        },
        getRowClassName(item, index) {
            // if (item.checkbox) {
            //     return "remove-row";
            // }
            if (
                (item.OpComplete == 1 && item.RemainQty == 0) ||
                item.RemainQty > item.RunQty
            ) {
                return "complete-row";
            } else {
                return index % 2 === 0 ? "even-row" : "odd-row";
            }
        },
        showTabletView(item) {
            this.passRowID = item.JobOperId;
            this.job_object = item;
            this.tabletViewDialog = true;
        },
        openReorderModal() {
            this.alertSuccess = false;
            const source = this.sortedFilteredTableData;
            this.reorderItems = source.map((item, index) => ({
                ...item,
                OriginalIndex: index,
            }));
            const { soonestDue, lowestRemQty } = this.getRecommendedJobs();
            this.recommendedSoonestDue = soonestDue;
            this.recommendedLowestRemQty = lowestRemQty;
            this.reorderDialog = true;
        },
        async saveReorder() {
            this.overlay = true;
            const changedRows = [];
            this.reorderItems.forEach((row, index) => {
                const newPriority = index + 1;
                if (index !== row.OriginalIndex) {
                    changedRows.push({
                        TabletId: row.TabletId,
                        Priority: newPriority,
                    });
                }
                row.Priority = newPriority;
            });
            if (changedRows.length === 0) {
                this.overlay = false;
                this.reorderDialog = false;
                return;
            }
            let formData = new FormData();
            changedRows.forEach((row, index) => {
                formData.append(`rows[${index}][TabletId]`, row.TabletId);
                formData.append(`rows[${index}][Priority]`, row.Priority);
            });
            console.log("Changed rows:", changedRows);
            try {
                await axios
                    .post(route("legacy-api.saveReorderTablet"), formData)
                    .then((res) => {
                        if (res.data.status === "SUCCESS") {
                            this.overlay = false;
                            this.alertSuccess = true;
                            setTimeout(() => {
                                this.reorderDialog = false;
                            }, 2000);
                            this.getJobs();
                        }
                    });
            } catch (err) {
                console.log(err);
            }
        },
        closeTabletView() {
            this.tabletViewDialog = false;
        },
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },
        sortArray(array) {
            array.sort(function (a, b) {
                if (a == null || b == null) {
                    return;
                }
                var nameA = a.toUpperCase(); // ignore upper and lowercase
                var nameB = b.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                // names must be equal
                return 0;
            });
            return array;
        },
        priorityThenActiveSort(a, b) {
            const aPriority = a.TabletPriority ?? null;
            const bPriority = b.TabletPriority ?? null;
            if (aPriority !== null && bPriority !== null) {
                return aPriority - bPriority;
            }
            if (aPriority !== null) return -1;
            if (bPriority !== null) return 1;
            return (b.Active ?? 0) - (a.Active ?? 0);
        },
        getRecommendedJobs() {
            if (!this.table.items.length)
                return { soonestDue: null, lowestRemQty: null };

            let soonestDue = this.table.items[0];
            let lowestRemQty = this.table.items[0];

            this.table.items.forEach((item) => {
                // Check soonest ShipByDate
                const itemDate = item.ShipByDate
                    ? new Date(item.ShipByDate).getTime()
                    : Infinity;
                const soonestDate = soonestDue.ShipByDate
                    ? new Date(soonestDue.ShipByDate).getTime()
                    : Infinity;
                if (itemDate < soonestDate) soonestDue = item;

                // Check lowest RemainQty
                const itemRem = item.RemainQty ?? Infinity;
                const lowestRem = lowestRemQty.RemainQty ?? Infinity;
                if (itemRem < lowestRem) lowestRemQty = item;
            });

            return { soonestDue, lowestRemQty };
        },
        // prepareForRemoval(item) {
        //     let result = window.confirm(
        //         "Are you sure you want to remove these jobs from the tablet?"
        //     );
        //     if (result) {
        //         console.log("Removing:", this.remove);
        //     }
        // },
    },
};
</script>

<style scoped>
.customize-table {
    --easy-table-header-font-size: 15px;
    --easy-table-header-font-color: #242939;
    --easy-table-header-background-color: #eee;
    --easy-table-header-font-color: #242939;

    --easy-table-body-row-height: 88px;
    --easy-table-body-row-font-size: 18px;

    --easy-table-footer-background-color: #ffffff;
    --easy-table-footer-font-color: #242939;
    --easy-table-footer-font-size: 15px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 55px;

    --easy-table-rows-per-page-selector-width: 75px;
    --easy-table-rows-per-page-selector-option-padding: 15px;

    --easy-table-body-row-hover-background-color: #eee;

    --easy-table-loading-mask-background-color: #ffffff;
}

:deep(.complete-row) {
    --easy-table-body-row-background-color: lightgreen !important;
}

/* :deep(.remove-row) {
    --easy-table-body-row-background-color: pink !important;
} */
:deep(.even-row) {
    --easy-table-body-row-background-color: #f5f5f5;
}

:deep(.odd-row) {
    --easy-table-body-row-background-color: white;
}

@keyframes fadeInOut {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

.active {
    color: green;
    animation: fadeInOut 2s ease-in-out infinite;
    font-size: 1.75em;
}

.inactive {
    color: red;
    font-size: 1.75em;
}

.timer {
    color: white;
    background: black;
    border: 1px solid white;
    border-radius: 4px;
}

.approved {
    color: green;
    font-size: 1.75em;
}

.semi-approved {
    color: orange;
    font-size: 1.75em;
}

.unapproved {
    color: red;
    font-size: 1.75em;
}
.toolbar-search-wrapper {
    position: absolute;
    top: 50%;
    right: clamp(8px, 5vw, 96px); /* responsive offset */
    transform: translateY(-50%);
    width: clamp(160px, 30vw, 320px);
}

@media (max-width: 768px) {
    .toolbar-search-wrapper {
        width: clamp(140px, 45vw, 260px);
    }
}

.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
    transition: transform 0.2s ease-in-out;
}

.scroll {
    overflow-y: auto;
}

table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td,
th {
    border: 1px solid #dddddd;
    padding: 8px;

    /* horizontal center */
    text-align: center;

    /* vertical center */
    vertical-align: middle;
}

tr:nth-child(even) {
    background-color: #dddddd;
}
tr.moved {
    box-shadow: inset 0 0 0 9999px rgba(255, 193, 7, 0.25);
}

.job-info {
    flex: 1;
}

.relative-toolbar {
    position: relative;
}

.toolbar-title-center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 2em;
    width: max-content;
}
</style>
